<template>
  <v-card
    class="d-flex justify-center ma-0 my-2"
    :class="[$vuetify.breakpoint.smAndDown ? 'row mx-4' : 'pl-4']"
    flat
  >
    <v-card
      max-width="200"
      class="rectangle col-4"
      v-for="(item, i) in rail"
      :key="i"
      :class="[
        { 'ml-3': i != 0 && $vuetify.breakpoint.mdAndUp },
        { 'col-12 mb-4': $vuetify.breakpoint.smAndDown }
      ]"
    >
      <div>
        <p class="subtitle-2 ma-0 pa-0">{{ item.name }}</p>
      </div>
      <div>
        <div class="outline-menu">
          <v-img class="menu" :src="item.icon"></v-img>
        </div>
      </div>
      <div class="stat">
        <p class="font-weight-medium my-0 headline number">{{ item.today | numFormat }}</p>
        <p class="subtitle-2 my-0">ครั้ง</p>
      </div>
      <v-row class="ma-0">
        <v-col cols="6" class="pa-0">
          <div class="text-center">
            <v-img
              contain
              height="32"
              :src="require('@/assets/icons/death.svg')"
              class="ma-0 mt-2"
            ></v-img>
            <!-- <i :class="`fas-fa-dizzy fa-2x`" class="ma-0 mt-2"></i> -->
          </div>
          <p class="title my-0">{{ item.dead | numFormat }}</p>
          <p class="subtitle-2 my-0">คน</p>
        </v-col>
        <v-col cols="6" class="pa-0">
          <div class="text-center">
            <i :class="`fas fa-user-injured fa-2x`" class="ma-0 mt-2"></i>
          </div>
          <p class="title my-0">{{ item.injury | numFormat }}</p>
          <p class="subtitle-2 my-0">คน</p>
        </v-col>
      </v-row>
    </v-card>
  </v-card>
</template>

<script>
export default {
  name: 'TodayRail',
  data: () => ({
    rail: []
  }),
  props: {
    searchParams: {
      type: Object,
      default: {}
    }
  },
  created() {
    this.getInitRoad();
  },
  mounted() {},
  watch: {
    searchParams() {
      this.getRail();
    }
  },
  methods: {
    init() {
      this.getRail();
    },
    getInitRoad() {
      this.rail = [
        {
          name: 'ทางรถไฟ',
          icon: require('@/assets/icons/train.svg'),
          today: 0,
          dead: 0,
          injury: 0
        },
        {
          name: 'รถไฟฟ้ามหานคร',
          icon: require('@/assets/icons/bts.svg'),
          today: 0,
          dead: 0,
          injury: 0
        },
        {
          name: 'รถไฟฟ้าแอร์พอร์ต เรล ลิงก์',
          icon: require('@/assets/icons/airlink.svg'),
          today: 0,
          dead: 0,
          injury: 0
        }
      ];
    },
    getRail() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/dashboard/network/rail`;
      delete this.searchParams.isBMTA;
      this.axios
        .get(url, { params: this.searchParams })
        .then(response => {
          if (response.status == 200 && response.data.data) {
            const { data } = response.data;
            const propname = ['srt', 'mrt', 'srtet'];
            for (let index = 0; index < propname.length; index++) {
              // const element = array[index];
              this.rail[index].today = data[propname[index]].amount;
              this.rail[index].dead = data[propname[index]].dead;
              this.rail[index].injury = data[propname[index]].injury;
            }
          }
        })
        .catch(function(error) {
          scope.rail = [];
          console.log(error);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.box {
  height: 100%;
  display: grid;
}

.col {
  padding-top: 0;
  padding-bottom: 0;
}

.col .img {
  padding: 0;
}

.card {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
  border-radius: 3px;
  margin-top: 15px;
}

.stat {
  background-color: white;
  margin: auto;
}

.number {
  color: #ba4438;
  text-align: center;
}

p {
  text-align: center;
}

.outline-menu {
  height: 100%;
  text-align: center;
}

.menu {
  width: 48px;
  height: 48px;
  margin: auto;
  top: calc(50% - 24px);
}

.sub-menu {
  width: 32px;
  height: 32px;
  margin: auto;
  top: calc(50% - 16px);
}

.rectangle {
  // width: 180px;
  height: 240px;
  border-radius: 3px;
  border: solid 1px #979797;
}
</style>
